var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg",staticStyle:{"text-align":"center"}},[_c('log-out')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }